export default "__VITE_ASSET__G6wAeKyD__"